import React from 'react';
import * as lqAction from './../action/loopQual';
import { connect } from 'react-redux'
import { Title } from '@vds/typography';
import { Button } from '@vds/buttons';
import * as buildProductAction from './../action/buildProduct';
import { Service } from './../constants/actionType'
import { catchJSException, updatePageLogs, checktime } from './../service/logService';
import Loader from './loader';
import PhoneNumber from './phoneNumber';
import Email from './email';
import { Input } from '@vds/inputs';
import { Checkbox } from '@vds/checkboxes';
import { FiosReferralKeyboard } from '../containers/fiosRetailTablet/Keyboard/FiosReferralKeyboard';
class FutureNotification extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            isKeyboardOn: false,
        };
        this.keyboard = React.createRef();
    }

    componentWillMount() {
        // let previousPage = this.props.appState.prevPage.pathname
        // let currentPage = this.props.location!==undefined?this.props.location.pathname:this.props.appState.currentPage.pathname;
        checktime(this.callCheckTime('WillMount'));
        this.inputTN = {}
        buildProductAction.updateFutureNotificationIntialStatus(this.props.appState.visitId, this.props.dispatch);
        //  if (previousPage !== currentPage) {
        //    this.props.dispatch({ type: "PAGE_VISITID", value: { prevPage: this.props.appState.currentPage, currentPage: this.props.location } });
        // }
    }

    isAlpha = (e) => {
        try {
            let pattern = /^[a-zA-Z]*$/;
            if ((e.key).match(pattern)) {
                return true;
            }
            else {
                e.preventDefault();
            }
        }
        catch (ex) {
            catchJSException('FNOverlay', this.props.visitId, 'FNOverlay_isAlpha', ex);
        }
    }

    callCheckTime = ((pagestate) => {
        return {
            page: 'FutureNotification',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false
        }
    })

    componentDidMount() {
        checktime(this.callCheckTime('Mount'));

        setTimeout(
            function () {
                updatePageLogs(this.props.appState, this.props.appState.visitId, false);
            }.bind(this), 500);
    }

    validateInput = (e) => {
        let targetid = e.target.id;
        lqAction.validateInput({ [targetid]: e.target.value }, this.props.dispatch);
    }

    updateEmail = (data) => {
        lqAction.validateInput({ eMailID: data.value }, this.props.dispatch);
    }

    updatePhoneNumberState = (id, value) => {
        lqAction.validateInput({ [id]: value }, this.props.dispatch);
    }

    ftvCheck = () => {
        lqAction.ftvCheck(this.props.lqState.futureNotification.ftvCheck, this.props.dispatch);
    }

    validateIpt = (pattern) => {
        (this.props.lqState.futureNotification.firstName === "") ? lqAction.fNameErr(true, this.props.dispatch) : lqAction.fNameErr(false, this.props.dispatch);
        (this.props.lqState.futureNotification.lastName === "") ? lqAction.lNameErr(true, this.props.dispatch) : lqAction.lNameErr(false, this.props.dispatch);
        (!this.props.lqState.futureNotification.ftvCheck) ? lqAction.ftvCheckErr(true, this.props.dispatch) : lqAction.ftvCheckErr(false, this.props.dispatch)
        if (this.props.lqState.futureNotification.phoneNo.ph1 !== '') {
            let TN = this.props.lqState.futureNotification.phoneNo.ph1;
            TN = TN.replace(/[^0-9]/g, '');
            if (TN.length !== 10) {
                lqAction.mtnErr(true, this.props.dispatch)
            }
            else {
                lqAction.mtnErr(false, this.props.dispatch)
                lqAction.mtn(TN, this.props.dispatch)
            }
        }
        else {
            lqAction.mtnErr(true, this.props.dispatch)
        }

        if (this.props.lqState.futureNotification.eMailID === "" || !pattern.test(this.props.lqState.futureNotification.eMailID)) {
            lqAction.emailErr(true, this.props.dispatch)
        }
        else {
            lqAction.emailErr(false, this.props.dispatch);
        }
    }

    submitRequest = () => {
        let addrID = "";
        let pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        let city = "";
        let unit = "";
        let state = "";
        let zip = "";
        let flowType = this.props.appState ? this.props.appState.flowType : "";

        if (flowType == "AF") {
            addrID = this.props.signInState && this.props.signInState.response && this.props.signInState.response.addressId ? this.props.signInState.response.addressId : "";

            unit = this.props.signInState && this.props.signInState.response && this.props.signInState.response.accountAddress && this.props.signInState.response.accountAddress.unitValue ? this.props.signInState.response.accountAddress.unitValue : "";

            if (this.props.signInState && this.props.signInState.response && this.props.signInState.response.accountAddress) {
                city = this.props.signInState.response.accountAddress.city;
                state = this.props.signInState.response.accountAddress.state;
                zip = this.props.signInState.response.accountAddress.zip;
            }
        }
        else {

            city = this.props.lqState.selectedState.city;

            if (this.props.lqState.isoneLQFlow) {
                city = this.props.lqState.selectedAdr && this.props.lqState.selectedAdr.muni ? this.props.lqState.selectedAdr.muni : this.props.lqState.selectedAdr && this.props.lqState.selectedAdr.city ? this.props.lqState.selectedAdr.city : "";
            }

            unit = (this.props.lqState.selectedUnit !== null && this.props.lqState.selectedUnit.unit !== null) ? this.props.lqState.selectedUnit.unit : ""
            //Without Unit
            if (unit === "") {
                addrID = (this.props.lqState && this.props.lqState.selectedAdr &&
                    this.props.lqState.selectedAdr.ntasAddrID !== "") ? this.props.lqState.selectedAdr.ntasAddrID : "";
            }
            //With Unit
            else {
                addrID = (this.props.lqState.selectedUnit !== null
                    && this.props.lqState.selectedUnit.addressId !== undefined
                    && this.props.lqState.selectedUnit.addressId !== null
                    && this.props.lqState.selectedUnit.addressId !== ""
                    && this.props.lqState.selectedUnit.addressId !== "N") ? this.props.lqState.selectedUnit.addressId : this.props.lqState.selectedAdr.addressID
            }
        }

        this.validateIpt(pattern);

        if (this.props.lqState.futureNotification.firstName !== "" && this.props.lqState.futureNotification.lastName !== "" && (this.props.lqState.futureNotification.eMailID !== "" && pattern.test(this.props.lqState.futureNotification.eMailID)) && this.props.lqState.futureNotification.phoneNo.ph1 !== '' && this.props.lqState.futureNotification.ftvCheck) {
            //visitId,telNbr,addrId,firstName,lastName,businessName,addressLine1,addressLine2,city,    state,zipCode,emailAddress,
            //contactPhone,vzPhone,notifyFios,notifyFiosTv,appId,nsiInd,dispatch
            let phonenumber = this.props.lqState.futureNotification.phoneNo.ph1;
            phonenumber = phonenumber.replace(/[^0-9]/g, '');
            let fiosData = 'Y';

            let services = this.props.lqState && this.props.lqState.lqResponse && this.props.lqState.lqResponse.services ? this.props.lqState.lqResponse.services : [];
            if (flowType == "AF") {
                services = this.props.signInState && this.props.signInState.response && this.props.signInState.response.services ? this.props.signInState.response.services : [];
            }

            services.forEach(key => {
                if (Service.FiOSData.indexOf(key.servicename.toUpperCase()) >= 0) {
                    if (key.qualified === "Y") {
                        fiosData = 'N';
                    }
                }
            });

            //this.props.dispatch({ type: ModalWindow.onModalWindowClose, value: ModalWindow.ids.notification })  

            if (this.props.nsiState.nsiIndicator === "Y" && this.props.lqState.futureNotification.ftvCheck) {
                buildProductAction.nsiNewRequest(this.props.dispatch, this.props.appState.visitId, addrID, flowType != "AF" ? this.props.lqState.selectedState.state : state, this.props.lqState.futureNotification.firstName, this.props.lqState.futureNotification.lastName, this.props.lqState.futureNotification.eMailID, phonenumber);
            }
            else {
                buildProductAction.updateFutureNotification(this.props.appState.visitId, phonenumber, addrID, this.props.lqState.futureNotification.firstName, this.props.lqState.futureNotification.lastName, "", flowType != "AF" ? this.props.lqState.selectedAdr.dispstr : "", unit, city, flowType != "AF" ? this.props.lqState.selectedState.state : state, flowType != "AF" ? this.props.lqState.selectedState.zip : zip, this.props.lqState.futureNotification.eMailID, phonenumber, "", fiosData, "Y", "NC", "", this.props.dispatch);
            }
        }
    }

    onKeyboardChange = (value) => {
        const { name } = this.state;
        try {
            if (name === 'firstName' || name === 'lastName') {
                lqAction.validateInput({ [name]: value }, this.props.dispatch);
            }else if (name === "phone1") {
                try {
                    let id = "ph1";
                    let currentPos = value.length;
                    const currentDashNo = value?.split('-').length;
                    const ph = this.formatPhoneNo(value);
                    const newDashNo = ph.split('-').length;

                    if(newDashNo  > currentDashNo){
                        currentPos = currentPos + 1;
                    }else if(newDashNo < currentDashNo){
                        currentPos = currentPos - 1;
                    }
                    this.updatePhoneNumberState(id, ph);
                }
                catch (ex) {
                    catchJSException('Checkout', this.props.visitId, 'personalInfo_phoneNumberKeyUpHandler', ex);
                }
            } else if (name === "email") {
                let pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                let pattern1 =/^[a-zA-Z0-9\s@._-]*$/;
    
                if (pattern.test(value) && pattern1.test(value)) {
                this.updateEmail({
                    value,
                    id: "eMailID",
                    isValidMail: true,
                    eMailErr: ""
                });
                } else {
                this.updateEmail({
                    value,
                    id: "eMailID",
                    isValidMail: false,
                    eMailErr: ""
                });
                }
                    }
                }
                catch (ex) {
                    catchJSException('Checkout', this.props.visitId, 'personalInfo_onNameChange', ex);

                }
    };

    formatPhoneNo = (value) => {
        var val = value.replace(/[^0-9]/g, '');
        if (value != null && value.length > 0) {          

            var number = val.split('');
            var check = 2;
            val = "";
            for (var count = 0; count < number.length; count++) {
                if (count < 10) {
                    if (count === check) {
                        val = val + number[count] + "-";
                        check = 5;
                    }
                    else
                        val = val + number[count];
                }
            }
            // if (val.lastIndexOf('-') > 0 && val.lastIndexOf('-') === (val.length - 1))
            //     val = this.removeLastHyphen(val);
        }       
        return val;
    }

    onKeyPressed = button => {
        if (button === "{accept}") {
            this.submitRequest();
        }
        if (button === "Clear") {
            this.updatePhoneNumberState("ph1", "");
            this.keyboard.current.setInput("");
        }
    };

    onKeyboardClicked = (e) => {
        const { name } = e.target;
        this.setState({ name, isKeyboardOn: true});      
    }

    onKeyboardClosed = (e) => {
        this.setState({ isKeyboardOn: false })
    }

    render() {
        const keyboardContainerClass = this.state.name === 'phone1' ? 'keyboard-container-for-save-future-number floating-keyboard-container' : 'keyboard-container-for-save-future-text floating-keyboard-container'
        const keyboardType = this.state.name === 'phone1'? 'numericLocker' : 'plantools';
        const keyboardEntryLimit = this.state.name === 'phone1' ? 10 : undefined;
        const keyboardBounds = this.state.name === 'phone1' ? { top:-150, left: -100, right: 400, bottom: 300 }  :  { top:-230, left: -100, right: 400, bottom: 300 };
        return (
            <div className="padding-all-zero savecart_modal">
                <Loader />
                <div className="row margin-vert-zero loop-qualification small-vert-middle">
                    <div className="tiny-p-100">
                        {/* <SideBanner bannerText="Let me know when Fios TV is available." /> */}
                        {/* <div className="LQR_SCM column tiny-12 small-9 loop-qualification_right m_loop-qualification_right-space saveCartLQ"> */}
                        {/* <SideBannerMobile bannerText="Let me know when Fios TV is available." /> */}
                        {/* <div className="row margin-vert-zero small-vert-middle  tiny-padding-all-zero" style={{ height: '372px' }}>
                            <div className="column tiny-padding-vert-zero small-padding-left-medium small-padding-right-small" style={{ verticalAlign: 'top' }}> */}
                        <div className="margin-bottom-medium">
                            <Title size="large" viewport="desktop" primitive="h1" color="black">
                                Let me know when Fios TV is available.
                                </Title>
                        </div>
                        <p className={this.props.lqState.futureNotification.validationsucess || this.props.lqState.futureNotification.validationfailure ? "hide" : "margin-horiz-tiny"}>
                            Fill out the request form below and we'll tell you when Fios is ready to order. We'll keep you updated along the way.</p>
                        <div className="row margin-vert-zero medium-margin-top-small" data-request-form-section="">
                            <div className="columns padding-vert-zero tiny-12">
                                <div id="datacollection" className={this.props.lqState.futureNotification.validationsucess || this.props.lqState.futureNotification.validationfailure ? "hide" : ""}>
                                    <div className="row">
                                        <div className="columns tiny-12 medium-6">
                                            <Input
                                                label="First name"
                                                name="firstName"
                                                type="text"
                                                inputId="firstName" tabIndex="0" onKeyDown={e => this.isAlpha(e)}
                                                required={true}
                                                onClick={e => this.onKeyboardClicked(e)}
                                                onChange={this.validateInput}
                                                value={this.props.lqState.futureNotification.firstName}
                                                error={this.props.lqState.futureNotification.fNameErr ? true : false} data-cs-mask
                                                errorText={this.props.lqState.futureNotification.fNameErr ? 'Please enter first name' : ''}
                                            />
                                        </div>
                                        <div className="columns tiny-12 medium-6">
                                            <Input
                                                label="Last name"
                                                name="lastName"
                                                onClick={e => this.onKeyboardClicked(e)}
                                                type="text"
                                                inputId="lastName" tabIndex="0" onKeyDown={e => this.isAlpha(e)}
                                                required={true}
                                                onChange={this.validateInput}
                                                value={this.props.lqState.futureNotification.lastName}
                                                error={this.props.lqState.futureNotification.lNameErr ? true : false} data-cs-mask
                                                errorText={this.props.lqState.futureNotification.lNameErr ? 'Please enter last name' : ''}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="column tiny-12">
                                            <Email className="margin-bottom-small value" tabIndex={0}
                                                id="eMailID"
                                                label="Email address"
                                                onClick={e => this.onKeyboardClicked(e)}
                                                hideStar={true} vds={true}
                                                updateEmail={(data) => this.updateEmail(data)}
                                                value={this.props.lqState.futureNotification.eMailID.replace(/ /g, "").toLowerCase()}
                                                error={this.props.lqState.futureNotification.emailErr ? true : false}
                                                emailErr={this.props.lqState.futureNotification.emailErr} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="column tiny-12 medium-12">
                                            <PhoneNumber valuePh1={this.props.lqState.futureNotification.phoneNo.ph1}
                                                hideStar={true} vds={true}
                                                onClick={e => this.onKeyboardClicked(e)}
                                                label="Phone number"
                                                updatePhoneNumberState={(id, value) => this.updatePhoneNumberState(id, value)}
                                                tnErr={this.props.lqState.futureNotification.mtnErr} /><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="column  tiny-12 medium-12">
                                            <Checkbox inputId="notifyFTV" tabIndex="0" className="value" onChange={this.ftvCheck} selected={this.props.lqState.futureNotification.ftvCheck}
                                                name="error" error={this.props.lqState.futureNotification.ftvCheckErr ? true :false } errorText={this.props.lqState.futureNotification.ftvCheckErr ? "Please select to notify" : ""}>
                                                Notify me when Fios TV is available.
                                                    </Checkbox><br />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="column  tiny-12 medium-12">
                                            <p className="margin-bottom-tiny">By submitting my request, I agree to receive an automated text message, call and email notifications when Fios becomes available in my area, including applicable offers.  Message and data rates may apply for texts.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="left tiny-margin-right-small">
                                            <Button Primary viewport="desktop" width="100%" onClick={this.submitRequest} size="large">Submit request</Button>
                                        </div>
                                    </div>
                                </div>
                                <div id="result" className={this.props.lqState.futureNotification.validationsucess || this.props.lqState.futureNotification.validationfailure ? "" : "hide"}>
                                    <div className="row">
                                        <div className={this.props.lqState.futureNotification.validationsucess ? "margin-horiz-small text-alert bold" : "hide"}>
                                            <p className="text-alert margin-horiz-tiny"> Thanks! We'll be in touch.as soon as FiosTV available in your area.</p>
                                        </div>
                                        <div className={this.props.lqState.futureNotification.validationfailure ? "margin-horiz-small text-alert bold" : "hide"}>
                                            <p className="text-alert margin-horiz-tiny"> Thanks! Service is down please try after some time .</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* </div> */}
                        {/* </div> */}
                        <FiosReferralKeyboard
                            onChange={this.onKeyboardChange}
                            onKeyPress={this.onKeyPressed}
                            inputName={this.state.name}
                            showKeyboard={this.state.isKeyboardOn}
                            closeKeyboard={this.onKeyboardClosed}
                            keyboardContainerClass={keyboardContainerClass}
                            theme={keyboardType}
                            keyboardEntryLimit={keyboardEntryLimit}
                            keyboard={this.keyboard}
                            planToolsWithSubmit={keyboardType === 'plantools' ? true : false}
                         />
                    </div>
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        appState: state.app,
        nsiState: state.nsi,
        signInState: state.signIn
    }
}

export default connect(
    mapStateToProps
)(FutureNotification);


